/* HEWI GA4 supplemental events (theme side).
   Complements the native Google & YouTube channel + the ga4-supplemental-events
   custom pixel. ONLY events neither source sends. NEVER add product_viewed /
   add_to_cart / checkout_* / purchase here — the native channel owns those and
   a second source double-counts every funnel metric and ads signal. */
(function () {
  var MID = 'G-Y9B7JDQ4W8';

  function track() {
    var args = arguments;
    if (typeof window.gtag !== 'function') {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
      window.gtag('config', MID, { send_page_view: false });
      if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
        var s = document.createElement('script');
        s.async = true;
        s.src = 'https://www.googletagmanager.com/gtag/js?id=' + MID;
        document.head.appendChild(s);
      }
    }
    window.gtag.apply(null, args);
  }

  /* WhatsApp offer + any element carrying data-hx-lead (generate_lead) —
     the negotiated-sale funnel that closes the largest orders. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-hx-lead]');
    if (!a) return;
    var payload = { lead_type: a.getAttribute('data-hx-lead') };
    if (a.dataset.hxValue) {
      payload.currency = a.dataset.hxCurrency || 'GBP';
      payload.value = parseFloat(a.dataset.hxValue) || 0;
    }
    if (a.dataset.hxItemId) {
      payload.items = [{ item_id: a.dataset.hxItemId, item_name: a.dataset.hxItemName || '' }];
    }
    track('event', 'generate_lead', payload);
  }, true);

  /* "Sell with us" intent — clicks into the selling funnel (supply side). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a || a.hasAttribute('data-hx-lead')) return;
    var h = a.getAttribute('href') || '';
    if (/\/how-it-works\/selling|\/pages\/how-it-works-selling|\/pages\/sell($|[/?#])/.test(h)) {
      track('event', 'generate_lead', { lead_type: 'seller' });
    }
  }, true);

  /* Newsletter signup — Klaviyo form success callback, not button click. */
  window.addEventListener('klaviyoForms', function (e) {
    if (e.detail && e.detail.type === 'submit') {
      track('event', 'sign_up', { method: 'newsletter' });
    }
  });

  /* Wishlist adds — Swym JS event layer. */
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    try {
      swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, function (ev) {
        var d = (ev && ev.detail && ev.detail.d) || {};
        var payload = { currency: 'GBP' };
        if (d.pr) payload.value = parseFloat(d.pr) || 0;
        if (d.empi && d.epi) {
          payload.items = [{ item_id: 'shopify_GB_' + d.empi + '_' + d.epi, item_name: d.dt || '' }];
        }
        track('event', 'add_to_wishlist', payload);
      });
    } catch (err) { /* Swym event layer unavailable — non-fatal */ }
  });
})();
